var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showTrailsPanel && _vm.panelVisible
    ? _c(
        "div",
        { staticClass: "lidar-container", attrs: { id: "trail_groups" } },
        [
          _c(
            "b-row",
            {
              staticClass: "w-100 blue-background tg-header",
              class: !_vm.panelMinimized ? "tg-header-border" : "",
              attrs: { "no-gutters": "" },
            },
            [
              _c(
                "b-col",
                {
                  staticClass:
                    "col-sm-9 d-flex justify-content-start align-items-center flex-row pl-4",
                },
                [
                  _c("span", { staticClass: "capitalize" }, [
                    _vm._v("Trail Groups"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass:
                    "col-sm-2 d-flex justify-content-center align-items-center",
                },
                [
                  _c("fa", {
                    staticClass: "float-right clickable",
                    attrs: {
                      id: "minOrMaxLidarPanelElement",
                      title: _vm.panelMinimized
                        ? "Maximize Lidar Panel"
                        : "Minimize Lidar Panel",
                      icon: [
                        "fas",
                        _vm.panelMinimized
                          ? "window-maximize"
                          : "window-minimize",
                      ],
                    },
                    on: {
                      click: function ($event) {
                        return _vm.togglePanelHeight()
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.panelMinimized
            ? _c(
                "b-row",
                {
                  staticClass: "w-100 scrollable p-2 tg-body",
                  attrs: { "no-gutters": "" },
                },
                [
                  !_vm.trailsLoading && _vm.distinct_trails.length > 0
                    ? _c(
                        "b-col",
                        {
                          staticClass:
                            "col-sm-12 m-0 p-0 d-flex justify-content-center align-items-center flex-column g-3",
                        },
                        _vm._l(_vm.distinct_trails, function (IDobj, index) {
                          return _c(
                            "b-row",
                            {
                              key: IDobj.dateCode,
                              staticClass: "w-100",
                              class: _vm.disableTrailGroups ? "disable" : "",
                              attrs: {
                                id: "trail_" + IDobj.dateCode,
                                "no-gutters": "",
                              },
                            },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass:
                                    "col-sm-10 d-flex justify-content-center align-items-center",
                                },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass:
                                        "btn py-1 lidar-label-size text-color",
                                      class:
                                        _vm.anyPointcloudOfTrailGroupVisible(
                                          IDobj.dateCode
                                        ),
                                      staticStyle: { padding: "0px" },
                                      attrs: {
                                        size: "sm",
                                        variant: "transparent",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleTrailsGroup(
                                            IDobj,
                                            $event
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(IDobj.dateCode) +
                                          "\n          "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass:
                                    "col-sm-2 d-flex justify-content-start align-items-center text-color",
                                },
                                [
                                  _c("fa", {
                                    staticClass: "clickable",
                                    attrs: {
                                      size: "lg",
                                      icon: [
                                        "fas",
                                        IDobj.groupIsCollapsed
                                          ? "caret-down"
                                          : "caret-up",
                                      ],
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.expandTrailGroup(IDobj)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              !IDobj.groupIsCollapsed
                                ? _c(
                                    "b-row",
                                    {
                                      staticClass: "w-100 mt-1",
                                      attrs: {
                                        id: "pointCloudContainer",
                                        "no-gutters": "",
                                      },
                                    },
                                    _vm._l(
                                      IDobj.pointcloudIDArr,
                                      function (pointcloudID) {
                                        return _c(
                                          "b-row",
                                          {
                                            key: pointcloudID.pc_id,
                                            staticClass:
                                              "w-100 d-flex justify-content-center align-items-center mt-1 pl-1 text-color",
                                            attrs: { "no-gutters": "" },
                                          },
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "col-sm-12 d-flex justify-content-center align-items-center",
                                              },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "b-tooltip",
                                                        rawName:
                                                          "v-b-tooltip.hover",
                                                        modifiers: {
                                                          hover: true,
                                                        },
                                                      },
                                                    ],
                                                    staticClass:
                                                      "btn w-100 text-truncate",
                                                    class:
                                                      _vm.availableTrailButtonCtrl(
                                                        pointcloudID.pc_id
                                                      ),
                                                    staticStyle: {
                                                      "font-size": "0.8rem",
                                                    },
                                                    attrs: {
                                                      size: "sm",
                                                      variant: "transparent",
                                                      id: `pc-${pointcloudID.pc_id}`,
                                                      title: pointcloudID.pc_id,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.toggleTrailLayer(
                                                          pointcloudID,
                                                          IDobj.dateCode
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                " +
                                                        _vm._s(
                                                          pointcloudID.pc_id
                                                        ) +
                                                        "\n              "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _vm.trailsLoading
                    ? _c(
                        "b-col",
                        {
                          staticClass:
                            "col-sm-12 m-0 p-0 d-flex justify-content-center align-items-center flex-column",
                        },
                        [
                          _c("b-row", { attrs: { "no-gutters": "" } }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "d-flex justify-content-center my-4",
                              },
                              [
                                _c("fa", {
                                  staticClass: "fa-spin tg-spinner",
                                  attrs: {
                                    icon: ["fas", "spinner"],
                                    size: "3x",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      )
                    : !_vm.lidarMinZoomAchieved
                    ? _c(
                        "b-col",
                        {
                          staticClass:
                            "col-sm-12 m-0 p-0 d-flex justify-content-center align-items-center flex-column",
                        },
                        [
                          _c(
                            "b-row",
                            {
                              staticClass:
                                "d-flex justify-content-center align-items-center w-100 tg-warning",
                              staticStyle: { gap: "15px" },
                              attrs: { "no-gutters": "" },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "d-flex justify-content-center",
                                },
                                [
                                  _c("fa", {
                                    attrs: {
                                      icon: ["fas", "exclamation-triangle"],
                                      size: "2x",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "d-flex justify-content-center",
                                },
                                [_vm._v("\n          Zoom Level 15+\n        ")]
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _c(
                        "b-col",
                        {
                          staticClass:
                            "col-sm-12 m-0 p-0 d-flex justify-content-center align-items-center flex-column",
                        },
                        [
                          _c("b-row", { attrs: { "no-gutters": "" } }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "d-flex justify-content-center mt-4",
                              },
                              [
                                _vm._v(
                                  "\n          No available Lidar at current location\n        "
                                ),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }